import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onBeforeUnmount, onMounted, ref } from "vue";
import {
  addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
  Timestamp,
} from "firebase/firestore";
import { db } from "@/firebase";
import { TimeDataKey } from "./time-data";
import type { TimeData } from "./time-data";

interface Message {
  name: string;
  message: string;
  createdAt: Timestamp;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'chat-panel',
  setup(__props, { expose }) {
  expose();

const { darkMode } = inject(TimeDataKey) as TimeData;

const inputName = ref<string>("");
const inputMessage = ref<string>("");
const messages = ref<Message[]>([]);

const postable = computed(() => {
  return inputName.value.trim() !== "" && inputMessage.value.trim() !== "";
});

const commentCollection = collection(db, "2022/messaging/okuribi");
let unsubscriber: () => void;

onMounted(() => {
  unsubscriber = onSnapshot(
    query(commentCollection, orderBy("createdAt", "asc")),
    {
      next: (snaps) => {
        for (const s of snaps.docChanges()) {
          const message = s.doc.data() as Message;
          switch (s.type) {
            case "added":
              messages.value.unshift(message);
              break;
          }
        }
      },
    }
  );
});

onBeforeUnmount(() => {
  unsubscriber();
});

const postMessage = async () => {
  if (!postable.value) return;
  const msg: Message = {
    name: inputName.value,
    message: inputMessage.value,
    createdAt: Timestamp.now(),
  };
  await addDoc(commentCollection, msg);
  inputName.value = "";
  inputMessage.value = "";
};

const getTime = (timestamp: Timestamp) => {
  const passed = new Date().getTime() - timestamp.toMillis();
  const min = passed / (60 * 1000);
  if (min < 1) {
    return "たった今";
  } else if (min < 59) {
    return Math.floor(min) + "分前";
  } else if (min < 24 * 60) {
    return Math.floor(min / 60) + "時間前";
  } else {
    const d = timestamp.toDate();
    return d.getMonth() + 1 + "月" + d.getDate() + "日";
  }
};

const __returned__ = { darkMode, inputName, inputMessage, messages, postable, commentCollection, unsubscriber, postMessage, getTime, computed, inject, onBeforeUnmount, onMounted, ref, addDoc, collection, onSnapshot, orderBy, query, Timestamp, db, TimeDataKey }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})